import LazyLoad from "react-lazy-load";

const HeroSellingPoints = () => {
  const heroItems = window.post_template.checkout_v4_product_hero.checkout_v4_selling_points;
  const sellingPointColor = window.post_template.checkout_v4_product_hero.checkout_v4_product_hero_sellingPointColor;
  const createHeroItems = () => {
    return heroItems.map((item, index) => (
      <div key={index} className="productHero__sellingPoints__item">
        <LazyLoad width={24} height={24}>
          <img src={item.checkout_v4_sellings_points_icon} alt={general_settings.brand_name} />
        </LazyLoad>
        <span style={{ color: sellingPointColor }}>{item.tr_checkout_v4_selling_points_title}</span>
      </div>
    ));
  };

  return heroItems && <div className="productHero__sellingPoints__container">{createHeroItems(heroItems)}</div>;
};

export default HeroSellingPoints;
